import { render } from "./HeroMain.vue?vue&type=template&id=1a44df5e&scoped=true&ts=true"
import script from "./HeroMain.vue?vue&type=script&lang=ts"
export * from "./HeroMain.vue?vue&type=script&lang=ts"

import "./HeroMain.vue?vue&type=style&index=0&id=1a44df5e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a44df5e"]])

export default __exports__